export default __webpack_public_path__ + "static/media/about_bradford_logo.ee9936da.svg";